import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/configurador-contribuciones-plaza';

/**
 * GET Contribuciones Plaza
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getContribucionesPlaza = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Contribución Plaza por ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getContribucionPlaza = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Contribución Plaza
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postContribucionPlaza = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Contribución Plaza
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchContribucionPlaza = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Contribución Plaza
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteContribucionPlaza = async (id) => {
  try {
    await API.delete(`${baseURI}/${id}`);
    onSuccess({}, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Contribución Plaza
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarContribucionPlaza = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, {
      estados_globales: ESTATUS_AUTORIZADO,
    });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
